export default __webpack_public_path__ + "static/media/config_3.3fe34daf.png";